import { isModifierClick } from '@lib/util/navigation.util'
import { ViewCompactItemType, type RenderableFile } from '@lib/types/files'
import useApiStore from '@browser/stores/api'
import useAppEmit from '@browser/composables/useAppEmit'

export function openItem(item: RenderableFile, e: MouseEvent) {
  const { state: apiState, actions: apiActions } = useApiStore()
  const isFolder = Boolean(
    ('type' in item && item.type !== ViewCompactItemType.File && 'folder' in item && item.folder) ||
      ('type' in item && item.type === ViewCompactItemType.Folder),
  )
  const isPage = Boolean('page' in item && item.file && item.page)

  if (isFolder) {
    useAppEmit().appEmit('onSectionChange', { section: 'all', folderId: item.id, newTab: isModifierClick(e) })

    return apiActions.setSearchQuery('')
  } else if (isPage && 'page' in item) {
    // extra page check in the if above for TS to understand what is going on
    apiState.fileOpener?.({
      fileId: item.file!.id,
      pageIndex: item.page!.page_index,
      newTab: isModifierClick(e),
    })

    return
  }

  const fileId = 'file' in item && item.file ? item.file.id : item.id
  const pageIndex = 'page_index' in item && item.page_index ? item.page_index : undefined
  apiState.fileOpener?.({ fileId: fileId, pageIndex, newTab: isModifierClick(e) })
}

export function openFolder(folderId: string) {
  useApiStore().actions.setSearchQuery('')
  useAppEmit().appEmit('onSectionChange', { section: 'all', folderId: folderId, newTab: false })
}
